import FairBanner from './FairBanner.jsx';

export {
  FairBanner
}


// WEBPACK FOOTER //
// ./components/fair/sub-view/banner/index.js